import React, { Component } from "react";
import { Tooltip, message } from "antd";
import copy from "clipboard-copy";
import { Copy } from "lucide-react";

import "./style.css";

message.config({
	top: 100,
	duration: 1
});

class CopyInput extends Component {
	state = {
		copied: false
	};

	copy = () => {
		const { value } = this.props;
		copy(value).then(() => {
			message.success("Copied");
			// Add highlight animation
			this.setState({ copied: true });
			// Remove highlight after animation
			setTimeout(() => {
				this.setState({ copied: false });
			}, 600);
		});
	};

	click = () => {
		const { value, link } = this.props;
		if (link) window.open(value, "_blank");
	};

	render() {
		const { value, link } = this.props;
		const { copied } = this.state;
		return (
			<div className="d-flex">
				<input
					readOnly
					className={"idg-copy-input " + (link ? "idg-copy-input-link " : "") + (copied ? "copied-highlight" : "")}
					value={value}
					onClick={this.click}
				/>
				<Tooltip title="Copy">
					<div className="idg-copy-input-suffix" onClick={this.copy}>
						<Copy size={18} />
					</div>
				</Tooltip>
			</div>
		);
	}
}

export default CopyInput;
